module.exports = __webpack_public_path__ + "img/4.a77d2a6d.jpg";